import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { ResetPasswordPromptDialog } from './ResetPasswordPromptDialog'
import type { SetPromptAction } from '@ztechapps/common.hook'
import type { TemplateVariables } from '../../Context'

export const PromptDialogEnum = {
  resetPassword: 'resetPassword',
}
export type PromptDialogProps = {
  variableName: string
  templateVariables: TemplateVariables
  setPromptAction: SetPromptAction
}
export const PromptDialog = ({ variableName, ...props }: PromptDialogProps) => {
  return (
    <div>
      <ShowIf condition={variableName === PromptDialogEnum.resetPassword}>
        <ResetPasswordPromptDialog variableName={variableName} {...props} />
      </ShowIf>
    </div>
  )
}
